import React from 'react';

import {
  Icon,
  Text,
  Spacer,
} from 'athenaeum';

import styles from './copyright.module.scss';

const Copyright = () => (
  <div
    className={styles.copyright}
  >
    <Text type={10} font="b">
      Copyright PolicyGenius © 2014-{new Date().getFullYear()}
      <br />
      <br />
      50 West 23rd St, Floor 9
      <br />
      New York, NY 10011
    </Text>
    <Spacer size={36} />
    <div className={styles['icon-list']}>
      <Icon
        icon="madeInNy"
        height="48px"
        width="48px"
        className={styles['made-in-ny']}
      />
      <Icon
        icon="norton"
        height="70px"
        width="75px"
      />
    </div>
  </div>
);

export default Copyright;



// WEBPACK FOOTER //
// ../src/templates/Footer/Copyright/index.js